import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './config';
//this is another comment for demonstaion purposes this is another change


// Trying to test everything in the merge requests
// this is a nother change for the final merge request
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV != 'test') {
  console.log(process.env.REACT_APP_ENV);
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=G-EYZMP7R3ZE`;
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-EYZMP7R3ZE');
    `;
  document.head.appendChild(inlineScript);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
loadConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
//small change with number small change

//this is a smal test change another change
//closes commit improved global issues one more time another one another one



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
